{
  "tid-document-capture-pres.instruction": "Make sure the whole page fits in the frame, and that the character strip is visible.",
  "tid-document-capture-pres.hint": "The scan will happen automatically",
  "tid-document-capture-pres.back": "Back",
  "tid-document-capture-pres.help": "Help",
  "tid-document-capture-pres.message.glare": "Move away from direct light to avoid reflections.",
  "tid-shared-tips-pres.title.mobile.scan.passport": "Tips for scanning",
  "tid-shared-tips-pres.continue.scan": "Retry",
  "tid-shared-tips-pres.cancel.passport": "Cancel",
  "tid-shared-summary-pres.passengerLabel": "Passenger: ",
  "tid-shared-summary-pres.nationalityLabel": "Nationality: ",
  "tid-shared-tips-pres.imageWholePage": "Include the whole page.",
  "tid-shared-tips-pres.imageBlur": "Make sure the page isn't blurry and there are no shadows.",
  "tid-shared-tips-pres.imageReflection": "Make sure there's no glare or reflection on the page.",
  "tid-identity-instruction-pres.altMrz": "Passport photo page with the character strip (Machine Readable Zone or MRZ) highlighted",
  "tid-collection-method-pres.methods": "Verify your passport",
  "tid-collection-method-pres.back": "Back",
  "tid-collection-method-pres.scanTitle": "Scan with camera",
  "tid-collection-method-pres.uploadTitle": "Upload a picture",
  "tid-header.flight": "Flight",
  "tid-header.passengerName": "Passenger",
  "tid-document-capture-pres.message.dark": "Move closer to a light source, the image is too dark.",
  "tid-gif-spinner.title.upload": "Uploading",
  "tid-gif-spinner.description.upload": "This may take up to 10 seconds.",
  "global.date-format.fullDateNumeric": "dd/MM/yyyy",
  "tid-gif-spinner.title.verify": "Verifying",
  "tid-gif-spinner.description.verify.passport": "We're verifying your passport.<br/>This may take up to 10 seconds."
}
